var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/shareWhite.01b48526.png","uri@2x": __webpack_public_path__ + "static/media/shareWhite.01b48526.png","uri@3x": __webpack_public_path__ + "static/media/shareWhite.f7686ad9.png",
    width: 36,
    height: 37
});